module.exports = __webpack_public_path__ + "img/40_37_014_340.19665009.jpg";